class BrandCarouselElement extends HTMLElement {
  constructor() {
    super();
    this.swiper = null; // To hold the swiper instance
    this.handleResize = this.handleResize.bind(this); // Bind the resize handler to 'this'
  }

  connectedCallback() {
    this.initSwiper(); // Initialize swiper when connected

    // Add a resize listener to check the screen width
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    // Cleanup the swiper instance and remove event listeners when disconnected
    this.destroySwiper();
    window.removeEventListener("resize", this.handleResize);
  }

  // Initialize Swiper only if the screen width is above 1024px
  initSwiper() {
    if (window.innerWidth > 1024 && !this.swiper) {
      // eslint-disable-next-line no-undef
      this.swiper = new Swiper(this.querySelector(".brand-carousel__container"), {
        slidesPerView: "auto",
        slidesPerGroup: 6,
        resistance: true, // Enable resistance
        resistanceRatio: 0, // Prevent surpassing boundaries
        navigation: {
          nextEl: ".brand-carousel__next.swiper-button-next",
          prevEl: ".brand-carousel__prev.swiper-button-prev",
        },
        a11y: {
          enabled: false,
        },
      });
    }
  }

  // Destroy the swiper instance if it exists
  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true); // Destroy swiper instance
      this.swiper = null; // Reset the swiper reference
      this.querySelector(".brand-carousel__container").classList.remove("swiper");
    }
  }

  // Handle the window resize to conditionally apply/remove Swiper
  handleResize() {
    if (window.innerWidth > 1024) {
      if (!this.swiper) {
        this.querySelector(".brand-carousel__container").classList.toggle("swiper");
        this.initSwiper(); // Initialize if not already applied
      }
    } else {
      this.destroySwiper(); // Destroy swiper when width is below 1024px
    }
  }
}

// Register the custom element
customElements.define("brand-carousel", BrandCarouselElement);
